import React, { useState } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { Headset } from '@mui/icons-material';

const AudioButton = ({ audioFile }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlePlay = () => {
    const audioPlayer = new Audio(URL.createObjectURL(audioFile)); // Create Audio object with the recorded audio file
    audioPlayer.play();
  };

  return (
    <>
      <Button variant="contained" color="primary" startIcon={<Headset />} onClick={handleOpen}>
  Audio Preview
</Button>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Audio Dialog</DialogTitle>
        <DialogContent>
          <audio controls>
            <source src={URL.createObjectURL(audioFile)} type="audio/webm" />
            Your browser does not support the audio element.
          </audio>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AudioButton;
